import { render } from "./NotificationListtItems.vue?vue&type=template&id=29d5b9e4&scoped=true"
import script from "./NotificationListtItems.vue?vue&type=script&lang=ts"
export * from "./NotificationListtItems.vue?vue&type=script&lang=ts"

import "./NotificationListtItems.vue?vue&type=style&index=0&id=29d5b9e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-29d5b9e4"

export default script